import ToDoScheduleEventDetail from './ToDoScheduleEventDetail';

const EditToDoScheduleEvent = () => <ToDoScheduleEventDetail mode="edit" />;

export default EditToDoScheduleEvent;
